export function Field({ id, label, value, onChange, type = "text", required, placeholder, className = "", ...rest }) {
  return (
    <div className={className}>
      <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">{label}{required && " *"}</label>
      <input
        data-testid={id}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2 text-sm outline-none focus:border-[var(--yp-primary)]"
        {...rest}
      />
    </div>
  );
}

export function Select({ id, label, value, onChange, options, required, className = "" }) {
  return (
    <div className={className}>
      <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">{label}{required && " *"}</label>
      <select
        data-testid={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2 text-sm outline-none focus:border-[var(--yp-primary)] bg-white"
      >
        <option value="">Select</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

export function TextArea({ id, label, value, onChange, rows = 3, required, placeholder, className = "" }) {
  return (
    <div className={className}>
      <label className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">{label}{required && " *"}</label>
      <textarea
        data-testid={id}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        required={required}
        className="mt-1 w-full border border-[var(--yp-border)] rounded-xl px-3 py-2 text-sm outline-none focus:border-[var(--yp-primary)]"
      />
    </div>
  );
}
